module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-44-28-788.ac6a9a88.mp4";